const DEVICE_VISITOR_ID_KEY = 'accessRegistrationDeviceVisitorId';
const CACHE_PREFIX = 'accessRegistrationCache';
const RECORD_LIMIT = 20;
const SHIP_HISTORY_LIMIT = 20;

export const ACCESS_REGISTRATION_MODULES = {
  person_in: {
    moduleType: 'person_in',
    path: '/home/access-registration/person-in',
    title: '人员入场',
    formTitle: '外来人员入场登记',
    successMessage: '登记成功，欢迎入场！',
    timeLabel: '入场时间',
    dictionaries: ['D_Access_CompanyType', 'D_Access_PersonVisitReason'],
    fields: [
      { type: 'text', key: 'name', label: '姓名', required: true, maxlength: 24, recent: true },
      { type: 'idCard', key: 'idCardNo', label: '身份证号', required: true, recent: true },
      { type: 'phone', key: 'phoneNumber', label: '手机号码', required: true },
      {
        type: 'select',
        key: 'companyTypeCode',
        label: '单位/个人',
        required: true,
        optionGroup: 'companyType',
        dicName: 'D_Access_CompanyType',
        defaultOptions: [
          { code: 'unit', description: '单位' },
          { code: 'personal', description: '个人' }
        ]
      },
      { type: 'text', key: 'companyName', label: '公司或单位名称', required: true, maxlength: 100, showIf: { key: 'companyTypeCode', value: 'unit' } },
      {
        type: 'select',
        key: 'reasonCode',
        label: '来访事由',
        required: true,
        optionGroup: 'reason',
        dicName: 'D_Access_PersonVisitReason',
        defaultOptions: [
          { code: 'dock_handling', description: '码头搬运作业' },
          { code: 'living_materials', description: '送生活物资（米油肉菜水等）' },
          { code: 'cargo_loading', description: '装卸货物物品' },
          { code: 'cargo_owner_check', description: '货主查看货物' },
          { code: 'maintenance', description: '设备检修维保' },
          { code: 'cargo_rectification', description: '货物整改（贴标等）' },
          { code: 'fire_safety_check', description: '消防安全检查' },
          { code: 'official_check', description: '执行公务检查' },
          { code: 'other', description: '其他' }
        ]
      },
      { type: 'textarea', key: 'reasonOther', label: '其他事由', required: true, maxlength: 200, showIf: { key: 'reasonCode', value: 'other' } },
      { type: 'datetime', key: 'passOrRegisterTime', label: '入场时间', required: true },
      { type: 'image', key: 'visitVoucherPhoto', label: '来访凭证照片', required: true, imageType: 'visit_voucher' }
    ],
    summaryFields: [
      { label: '姓名', key: 'name' },
      { label: '手机号码', key: 'phoneNumber' },
      { label: '来访事由', key: 'reasonCode', optionGroup: 'reason' }
    ]
  },
  person_out: {
    moduleType: 'person_out',
    path: '/home/access-registration/person-out',
    title: '人员离场',
    formTitle: '外来人员离场登记',
    successMessage: '登记成功，祝您一路顺利',
    timeLabel: '离场时间',
    dictionaries: ['D_Access_CertificateReturnStatus'],
    fields: [
      { type: 'text', key: 'name', label: '姓名', required: true, maxlength: 24, recent: true },
      { type: 'idCard', key: 'idCardNo', label: '身份证号', required: true, recent: true },
      { type: 'datetime', key: 'passOrRegisterTime', label: '离场时间', required: true },
      {
        type: 'select',
        key: 'certificateReturnStatusCode',
        label: '来访证归还情况',
        required: true,
        optionGroup: 'certificateReturnStatus',
        dicName: 'D_Access_CertificateReturnStatus',
        defaultOptions: [
          { code: 'returned', description: '已归还' },
          { code: 'not_returned', description: '未归还' }
        ]
      },
      {
        type: 'textarea',
        key: 'certificateReturnRemark',
        label: '未归还原因',
        required: true,
        maxlength: 200,
        showIf: { key: 'certificateReturnStatusCode', value: 'not_returned' }
      }
    ],
    summaryFields: [
      { label: '姓名', key: 'name' },
      { label: '身份证号', key: 'idCardNo' },
      { label: '离场时间', key: 'passOrRegisterTime', format: 'time' }
    ]
  },
  vehicle_in: {
    moduleType: 'vehicle_in',
    path: '/home/access-registration/vehicle-in',
    title: '车辆入场',
    formTitle: '外来车辆入场登记',
    successMessage: '登记成功，欢迎入场！',
    timeLabel: '入场时间',
    dictionaries: ['D_Access_VehicleType', 'D_Access_VehicleInReason'],
    fields: [
      { type: 'text', key: 'name', label: '司机姓名', required: true, maxlength: 24, recent: true },
      { type: 'phone', key: 'phoneNumber', label: '手机号码', required: true },
      { type: 'idCard', key: 'idCardNo', label: '身份证号', required: true, recent: true },
      {
        type: 'select',
        key: 'hasCompanion',
        label: '有无随车同行人员',
        required: true,
        optionGroup: 'hasCompanion',
        defaultOptions: [
          { code: 'no', description: '无' },
          { code: 'yes', description: '有' }
        ]
      },
      { type: 'text', key: 'companionName', label: '副驾驶位人员姓名', required: true, maxlength: 24, showIf: { key: 'hasCompanion', value: 'yes' } },
      { type: 'idCard', key: 'companionIdCardNo', label: '副驾驶位人员身份证号', required: true, showIf: { key: 'hasCompanion', value: 'yes' } },
      { type: 'phoneInput', key: 'companionPhoneNumber', label: '副驾驶位人员手机号码', required: true, showIf: { key: 'hasCompanion', value: 'yes' } },
      { type: 'plate', key: 'plateNumber', label: '车牌号', required: true },
      {
        type: 'select',
        key: 'vehicleTypeCode',
        label: '车辆类型',
        required: true,
        optionGroup: 'vehicleType',
        dicName: 'D_Access_VehicleType',
        defaultOptions: [
          { code: 'truck', description: '货车' },
          { code: 'special_engineering', description: '特种作业工程车' },
          { code: 'official', description: '公务车' },
          { code: 'private', description: '私家车' },
          { code: 'other', description: '其他车辆' }
        ]
      },
      {
        type: 'select',
        key: 'reasonCode',
        label: '入场事由',
        required: true,
        optionGroup: 'reason',
        dicName: 'D_Access_VehicleInReason',
        defaultOptions: [
          { code: 'delivery', description: '送货' },
          { code: 'pickup_goods', description: '提货' },
          { code: 'maintenance', description: '施工检测维保' },
          { code: 'official_check', description: '执行公务检查' },
          { code: 'disinfection', description: '卫生消毒处理' },
          { code: 'dock_handling', description: '码头搬运作业' },
          { code: 'other', description: '其他' }
        ]
      },
      { type: 'textarea', key: 'reasonOther', label: '其他事由', required: true, maxlength: 200, showIf: { key: 'reasonCode', value: 'other' } },
      { type: 'datetime', key: 'passOrRegisterTime', label: '入场时间', required: true },
      { type: 'image', key: 'vehicleOuterPhoto', label: '车辆外观照片', required: true, imageType: 'vehicle_outer' }
    ],
    summaryFields: [
      { label: '司机姓名', key: 'name' },
      { label: '车牌号', key: 'plateNumber' },
      { label: '车辆类型', key: 'vehicleTypeCode', optionGroup: 'vehicleType' }
    ]
  },
  vehicle_out: {
    moduleType: 'vehicle_out',
    path: '/home/access-registration/vehicle-out',
    title: '车辆离场',
    formTitle: '外来车辆离场登记',
    successMessage: '登记成功，祝您一路顺利',
    timeLabel: '离场时间',
    dictionaries: ['D_Access_VehicleCargoStatus'],
    fields: [
      { type: 'text', key: 'name', label: '司机姓名', required: true, maxlength: 24, recent: true },
      { type: 'plate', key: 'plateNumber', label: '车牌号', required: true },
      {
        type: 'select',
        key: 'vehicleHasCargoCode',
        label: '车上是否载有货物',
        required: true,
        optionGroup: 'cargoStatus',
        dicName: 'D_Access_VehicleCargoStatus',
        defaultOptions: [
          { code: 'yes', description: '有' },
          { code: 'no', description: '没有' }
        ]
      },
      { type: 'image', key: 'cargoTicketPhoto', label: '提货单/散货交接单', required: true, imageType: 'cargo_ticket', showIf: { key: 'vehicleHasCargoCode', value: 'yes' } },
      { type: 'image', key: 'vehicleInnerPhoto', label: '车厢内部照片', required: true, imageType: 'vehicle_inner', showIf: { key: 'vehicleHasCargoCode', value: 'yes' } },
      { type: 'datetime', key: 'passOrRegisterTime', label: '离场时间', required: true }
    ],
    summaryFields: [
      { label: '司机姓名', key: 'name' },
      { label: '车牌号', key: 'plateNumber' },
      { label: '是否载货', key: 'vehicleHasCargoCode', optionGroup: 'cargoStatus' }
    ]
  },
  crew_luggage_in: {
    moduleType: 'crew_luggage_in',
    path: '/home/access-registration/crew-luggage-in',
    title: '携带行李入闸',
    formTitle: '携带行李入闸登记',
    successMessage: '登记成功，欢迎入闸！',
    timeLabel: '入闸时间',
    crewDirection: 'in',
    hasLuggage: true
  },
  crew_luggage_out: {
    moduleType: 'crew_luggage_out',
    path: '/home/access-registration/crew-luggage-out',
    title: '携带行李出闸',
    formTitle: '携带行李出闸登记',
    successMessage: '登记成功，祝您一路顺利',
    timeLabel: '出闸时间',
    crewDirection: 'out',
    hasLuggage: true
  },
  crew_no_luggage_in: {
    moduleType: 'crew_no_luggage_in',
    path: '/home/access-registration/crew-no-luggage-in',
    title: '无行李入闸',
    formTitle: '无行李入闸登记',
    successMessage: '登记成功，欢迎入闸！',
    timeLabel: '入闸时间',
    crewDirection: 'in',
    hasLuggage: false
  },
  crew_no_luggage_out: {
    moduleType: 'crew_no_luggage_out',
    path: '/home/access-registration/crew-no-luggage-out',
    title: '无行李出闸',
    formTitle: '无行李出闸登记',
    successMessage: '登记成功，祝您一路顺利',
    timeLabel: '出闸时间',
    crewDirection: 'out',
    hasLuggage: false
  }
};

const CREW_IN_REASON_OPTIONS = [
  { code: 'back_from_vacation', description: '结束休假后上船工作' },
  { code: 'return_from_purchase', description: '外出采购物资后返回' },
  { code: 'return_from_personal_affairs', description: '办理个人事务后返回' },
  { code: 'inspection_cooperation', description: '配合海关、边检等检查' },
  { code: 'other', description: '其他' }
];

const CREW_OUT_REASON_OPTIONS = [
  { code: 'vacation_home', description: '休假回家' },
  { code: 'purchase_goods', description: '采购物资' },
  { code: 'crew_shift', description: '船员换班' },
  { code: 'inspection_cooperation', description: '配合检查' },
  { code: 'other', description: '其他' }
];

function buildCrewFields(direction) {
  const isIn = direction === 'in';
  return [
    { type: 'image', key: 'idCardOcrPhoto', label: '身份证识别原图', required: false, imageType: 'id_card_ocr', hint: '当前版本不接 OCR，上传原图后仍需手动填写姓名和身份证号。' },
    { type: 'text', key: 'name', label: '姓名', required: true, maxlength: 24, recent: true },
    { type: 'idCard', key: 'idCardNo', label: '身份证号', required: true, recent: true },
    { type: 'phone', key: 'phoneNumber', label: '手机号码', required: true },
    { type: 'shipName', key: 'shipName', label: '所属船舶名称', required: true, maxlength: 100 },
    {
      type: 'select',
      key: 'reasonCode',
      label: isIn ? '入闸事由' : '出闸事由',
      required: true,
      optionGroup: 'reason',
      dicName: isIn ? 'D_Access_CrewInReason' : 'D_Access_CrewOutReason',
      defaultOptions: isIn ? CREW_IN_REASON_OPTIONS : CREW_OUT_REASON_OPTIONS
    },
    { type: 'textarea', key: 'reasonOther', label: '其他事由', required: true, maxlength: 200, showIf: { key: 'reasonCode', value: 'other' } },
    { type: 'datetime', key: 'passOrRegisterTime', label: isIn ? '入闸时间' : '出闸时间', required: true },
    { type: 'number', key: 'temperature', label: '体温（℃）', required: true, placeholder: '例如 36.5' }
  ];
}

Object.values(ACCESS_REGISTRATION_MODULES).forEach(config => {
  if (config.crewDirection) {
    config.dictionaries = [config.crewDirection === 'in' ? 'D_Access_CrewInReason' : 'D_Access_CrewOutReason'];
    config.fields = buildCrewFields(config.crewDirection);
    config.summaryFields = [
      { label: '姓名', key: 'name' },
      { label: '所属船舶名称', key: 'shipName' },
      { label: '事由', key: 'reasonCode', optionGroup: 'reason' }
    ];
  }
});

export const ACCESS_REGISTRATION_GROUPS = [
  {
    title: 'A. 外来人员登记',
    desc: '适用于访客入场、离场登记',
    moduleTypes: ['person_in', 'person_out']
  },
  {
    title: 'B. 外来车辆登记',
    desc: '适用于车辆进出场登记',
    moduleTypes: ['vehicle_in', 'vehicle_out']
  },
  {
    title: 'C. 船员信息登记',
    desc: '适用于船员携带/未携带行李出入闸登记',
    moduleTypes: ['crew_luggage_in', 'crew_luggage_out', 'crew_no_luggage_in', 'crew_no_luggage_out']
  }
];

export function getAccessRegistrationConfig(moduleType) {
  return ACCESS_REGISTRATION_MODULES[moduleType] || null;
}

export function getAccessRegistrationGroups() {
  return ACCESS_REGISTRATION_GROUPS.map(group => ({
    ...group,
    items: group.moduleTypes.map(moduleType => ACCESS_REGISTRATION_MODULES[moduleType]).filter(Boolean)
  }));
}

function safeParse(json, fallback) {
  try {
    return JSON.parse(json);
  } catch (error) {
    return fallback;
  }
}

function buildCacheKey(moduleType, suffix) {
  return `${CACHE_PREFIX}:${moduleType}:${suffix}`;
}

function uniqueValues(values = []) {
  return [...new Set(values.filter(Boolean).map(item => String(item).trim()).filter(Boolean))];
}

export function getDeviceVisitorId() {
  const current = localStorage.getItem(DEVICE_VISITOR_ID_KEY);
  if (current) {
    return current;
  }

  const generated = `dvi_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  localStorage.setItem(DEVICE_VISITOR_ID_KEY, generated);
  return generated;
}

export function getCachedPhone() {
  return (localStorage.getItem(buildCacheKey('global', 'phone')) || '').trim();
}

export function setCachedPhone(phone) {
  if (!phone) {
    return;
  }

  localStorage.setItem(buildCacheKey('global', 'phone'), String(phone).trim());
}

export function getModuleRecords(moduleType) {
  return safeParse(localStorage.getItem(buildCacheKey(moduleType, 'records')) || '[]', []);
}

export function setModuleRecords(moduleType, records = []) {
  localStorage.setItem(
    buildCacheKey(moduleType, 'records'),
    JSON.stringify((records || []).slice(0, RECORD_LIMIT))
  );
}

export function mergeModuleRecords(moduleType, incoming = []) {
  const localRecords = getModuleRecords(moduleType);
  const map = new Map();

  [...incoming, ...localRecords].forEach(record => {
    if (!record) {
      return;
    }

    const key = record.id || record.recordNo || record.submitTime || Math.random().toString(36);
    if (!map.has(key)) {
      map.set(key, record);
    }
  });

  const merged = [...map.values()].sort((a, b) => {
    const left = new Date(b.submitTime || b.passOrRegisterTime || 0).getTime();
    const right = new Date(a.submitTime || a.passOrRegisterTime || 0).getTime();
    return left - right;
  });

  setModuleRecords(moduleType, merged);
  return merged;
}

export function appendModuleRecord(moduleType, record) {
  const merged = mergeModuleRecords(moduleType, [record]);
  setModuleRecords(moduleType, merged);
  return merged;
}

export function cacheRecentFormValues(moduleType, values = {}) {
  const nameValues = uniqueValues([values.name, ...getRecentValues(moduleType, 'name')]).slice(0, 5);
  const idCardValues = uniqueValues([values.idCardNo, ...getRecentValues(moduleType, 'idCardNo')]).slice(0, 5);

  localStorage.setItem(buildCacheKey(moduleType, 'recentNameValues'), JSON.stringify(nameValues));
  localStorage.setItem(buildCacheKey(moduleType, 'recentIdCardValues'), JSON.stringify(idCardValues));

  if (values.phoneNumber) {
    setCachedPhone(values.phoneNumber);
  }

  if (values.shipName) {
    cacheShipName(values.shipName);
  }
}

export function getRecentValues(moduleType, field) {
  const suffix = field === 'name' ? 'recentNameValues' : 'recentIdCardValues';
  return safeParse(localStorage.getItem(buildCacheKey(moduleType, suffix)) || '[]', []);
}

export function getLatestRecord(moduleType) {
  return getModuleRecords(moduleType)[0] || null;
}

export function getShipNameHistory() {
  return safeParse(localStorage.getItem(buildCacheKey('global', 'shipNames')) || '[]', []);
}

export function cacheShipName(shipName) {
  const values = uniqueValues([shipName, ...getShipNameHistory()]).slice(0, SHIP_HISTORY_LIMIT);
  localStorage.setItem(buildCacheKey('global', 'shipNames'), JSON.stringify(values));
  return values;
}

export function findLatestRecordByShipName(shipName) {
  const target = String(shipName || '').trim();
  if (!target) {
    return null;
  }

  const crewModuleTypes = Object.values(ACCESS_REGISTRATION_MODULES)
    .filter(item => item.crewDirection)
    .map(item => item.moduleType);

  return crewModuleTypes
    .flatMap(moduleType => getModuleRecords(moduleType))
    .filter(record => record && record.shipName === target)
    .sort((a, b) => {
      const left = new Date(b.submitTime || b.passOrRegisterTime || 0).getTime();
      const right = new Date(a.submitTime || a.passOrRegisterTime || 0).getTime();
      return left - right;
    })[0] || null;
}
